import React from "react"
import Loadable from '@loadable/component'
import {useStaticQuery, graphql} from "gatsby"

const LineChartCauseOfDeath = () => {
const data = useStaticQuery(graphql`
  {
    allDeathNcdCdPctCsv {
      edges {
        node {
          CD_pct
          Injuries_pct
          NCD_pct
          Year
        }
      }
    }
  }
  `);

const datapoints = data.allDeathNcdCdPctCsv.edges;


const date_data = Object.keys(datapoints).map(key => datapoints[key].node.Year);
const CD_pct_data =  Object.keys(datapoints).map(key => datapoints[key].node.CD_pct);
const Injuries_pct_data = Object.keys(datapoints).map(key => datapoints[key].node.Injuries_pct);
const NCD_pct_data = Object.keys(datapoints).map(key => datapoints[key].node.NCD_pct);
  return (
<>
<LoadableChart
options={{
  dataLabels: {enabled: false},

  title: {
    text: 'Causes of death'
  },
  legend: {position: 'top',},
  chart: {
    id: "basic-line"
  },
  xaxis: {
      title: {
    text: 'Date'
  },
    categories: date_data,
    type: "datetime",
  },
    yaxis: {
      title: {
    text: 'Percentage of all deaths'
  },
      labels: {
              formatter: (value) => { return value + "%" },
          },
      // min:0,


    },
  tooltip: {
  x: {
    formatter: (value) => { return new Date(value).getUTCFullYear()},
  },}
}}
series={[
  {
    name: "Aging",
    data: NCD_pct_data
  },
  {
    name: "Communicable, maternal, neonatal, and nutritional",
    data: CD_pct_data
  },
  {
    name: "Injuries",
    data: Injuries_pct_data
  },
]}
type="line"

/>
</>)
};

export default LineChartCauseOfDeath

// import react-apexcharts here
const LoadableChart = Loadable(() => import('../../node_modules/react-apexcharts/src/react-apexcharts'));
